import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { getTermsTitle } from 'constants/IncorporationConstants';

export const PageHeader = ({ titleSvcType }) => {
  return (
    <div className="brity-title-area">
      <div className="brity-title">
        <h1>
          <Trans i18nKey={getTermsTitle(titleSvcType).title} />
        </h1>
      </div>
      {getTermsTitle(titleSvcType).subTitle && (
        <div className="brity-subtitle" style={{ wordBreak: 'normal' }}>
          <Trans i18nKey={getTermsTitle(titleSvcType).subTitle} />
        </div>
      )}
    </div>
  );
};
PageHeader.propTypes = { titleSvcType: PropTypes.string };
PageHeader.defaultProps = { titleSvcType: null };
export default PageHeader;
